import { MotorbikeElectricIcon } from './MotorbikeElectricIcon';

/**
 * author: Michael Irigoyen
 * id 91B25A35-38AC-497B-A0D8-82053E09E43A
 * name motorbike-electric
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/motorbike-electric.svg
 * tags
 * - Transportation + Road 
 */
export const MotorcycleElectricIcon = MotorbikeElectricIcon;
export default MotorcycleElectricIcon